// LeavePermissionReport

import { useState } from "react";
import { Reactable } from "../../components/ui/reactable";
import { ReportPageShell } from "../../components/ui/reportPageShell";
import { LEAVE_PERMISSION_REPORT } from "../../constants/api";
import { EmployeeDetails } from "../../components/ui/cards";

const LeavePermissionReport = () => {

    const [leavePermissionReportData, setLeavePermissionReportData] = useState([]);
    const [totalRecords, setTotalRecords] = useState(0);
        const LeavePermissionReportColumns = [
        {
            accessor: "employee_name",
            Header: "Employee",
            sortable: true,
            fixed: true,
            filterable: true,
            maxWidth: "300px",
            Cell: ({ value, row }) => {
                const record = row;

                let empDetails = {
                    ...record?.employee,
                    designation_id: record?.employee?.designation
                        ? {
                            id: record?.employee.designation.id,
                            designation_name: record?.employee.designation.name,
                        }
                        : { id: 0, designation_name: "" },
                    first_name: record?.employee?.employee_name || "-",
                    id: record?.employee?.employee_id || "-",
                };

                return <EmployeeDetails details={empDetails} size="xs" />;
            },
        },
        {
            accessor: "leave_type",
            Header: "Leave Type",
            Cell: ({ value }) => value ?? "-",
        },
        {
            accessor: "request_raised_date",
            Header: "Req Raised Date/Time",
            Cell: ({ value }) => value ?? "-",
        },
        {
            accessor: "from_date",
            Header: "Req Date/Time",
            filterable: true,
            Cell: ({ value }) => value ?? "-",
        },
        {
            accessor: "approved_date",
            Header: "Approved Date/Time",
            Cell: ({ value }) => value ?? "-",
        },
        {
            accessor: "approved_by",
            Header: "Approved By",
            Cell: ({ value }) => value ?? "-",
        }
    ];

    return (
        <ReportPageShell title="Leave Permission Report " count={totalRecords}>

            <Reactable
                columns={LeavePermissionReportColumns}
                data={leavePermissionReportData}
                setData={setLeavePermissionReportData}
                setTotalCount={setTotalRecords}
                url={LEAVE_PERMISSION_REPORT}
                serverSide={true}
                rowSize="sm"
                isCSVRequired={true}
                isPDFRequired={true}
                isFromToDateRequired={true}
            />
        </ReportPageShell>
    );
}

export default LeavePermissionReport;